var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// @ts-check
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SHARED_STYLES } from '../css/shared-css.js';
let ChromedashReportExternalReviewsDispatchPage = class ChromedashReportExternalReviewsDispatchPage extends LitElement {
    static get styles() {
        return SHARED_STYLES;
    }
    render() {
        return html `
      <div id="subheader">Which group's reviews do you want to see?</div>
      <ul>
        <li><a href="/reports/external_reviews/tag">W3C TAG</a></li>
        <li>
          <a href="/reports/external_reviews/gecko"
            >Gecko / Firefox / Mozilla</a
          >
        </li>
        <li>
          <a href="/reports/external_reviews/webkit">WebKit / Safari / Apple</a>
        </li>
      </ul>
    `;
    }
};
ChromedashReportExternalReviewsDispatchPage = __decorate([
    customElement('chromedash-report-external-reviews-dispatch-page')
], ChromedashReportExternalReviewsDispatchPage);
export { ChromedashReportExternalReviewsDispatchPage };
